enum LeaderboardUserLevel {
  green_ribbon = "green_ribbon",
  red_ribbon = "red_ribbon",
  blue_ribbon = "blue_ribbon",
  bronze_medal = "bronze_medal",
  silver_medal = "silver_medal",
  gold_medal = "gold_medal",
  bronze_trophy = "bronze_trophy",
  silver_trophy = "silver_trophy",
  gold_trophy = "gold_trophy",
  bronze_crown = "bronze_crown",
  silver_crown = "silver_crown",
  gold_crown = "gold_crown",
  diamond = "diamond",
  jadeite = "jadeite",
  rubellite = "rubellite",
  tanzanite = "tanzanite",
}

type LeaderboardUser = {
  name: string;
  points: number;
  avatar: string;
  link: string;
  company: string;
  level: LeaderboardUserLevel;
};

type Leaderboard = {
  type: LeaderboardUserLevel;
  items: [LeaderboardUser];
};

export { Leaderboard, LeaderboardUser, LeaderboardUserLevel };
